import React, { createContext } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Col } from "react-bootstrap";
import * as actions from "MODULES/PurchaseOrders/actions";
import CoBuyerField from "./CoBuyerField";
import ThirdBuyerField from "./ThirdBuyerField";

export const createBuyersContext = (
  selectedCoBuyer,
  selectedThirdBuyer,
  toggleBuyer
) =>
  createContext({
    selectedCoBuyer,
    selectedThirdBuyer,
    toggleBuyer
  });

function CoBuyersFields({
  buyerCreditPct,
  colSize = 6,
  disabled,
  numberOfBuyers,
  searchBuyers,
  selectedCoBuyer,
  selectedThirdBuyer,
  toggleBuyer
}) {
  return [
    <Col md={colSize}>
      <CoBuyerField
        buyerCreditPct={buyerCreditPct}
        searchBuyers={searchBuyers}
        selectedCoBuyer={selectedCoBuyer}
        selectedThirdBuyer={selectedThirdBuyer}
        disabled={disabled}
        numberOfBuyers={numberOfBuyers}
        toggleBuyer={toggleBuyer}
      />
    </Col>,
    <Col md={colSize}>
      <ThirdBuyerField
        buyerCreditPct={buyerCreditPct}
        disabled={disabled}
        numberOfBuyers={numberOfBuyers}
        searchBuyers={searchBuyers}
        selectedCoBuyer={selectedCoBuyer}
        selectedThirdBuyer={selectedThirdBuyer}
        toggleBuyer={toggleBuyer}
      />
    </Col>
  ];
}

CoBuyersFields.propTypes = {
  buyerCreditPct: PropTypes.string,
  colSize: PropTypes.number,
  disabled: PropTypes.bool,
  numberOfBuyers: PropTypes.number.isRequired,
  searchBuyers: PropTypes.func.isRequired,
  selectedCoBuyer: PropTypes.instanceOf(Object),
  selectedThirdBuyer: PropTypes.instanceOf(Object)
};

export default connect(undefined, dispatch => ({
  searchBuyers: filter => dispatch(actions.searchBuyers(filter))
}))(CoBuyersFields);



// WEBPACK FOOTER //
// ./app/modules/shared/components/CoBuyersFields/CoBuyersFields.jsx